import { CSSObject } from '@chakra-ui/react';

export const DeductionsText: CSSObject = {
  color: 'whiteAlpha.700',
  mb: '1',
  fontSize: '2xs',
  fontWeight: 'semibold',
};

export const FooterMoreOpenText: CSSObject = {
  color: 'alpha.500',
  fontSize: 'xs',
  fontWeight: 'bold',
  borderTop: '1px dashed',
  borderBottom: '1px dashed',
  // TODO: This value and below blackAlpha should be identical value. But look vastly different. Needs review
  borderColor: 'blackAlpha.200',
  mx: '2',

  '&&': {
    px: '0',
  },
};

export const BoxMoreText: CSSObject = {
  w: '8',
};

export const DividerMulti: CSSObject = {
  borderStyle: 'dashed',
  borderColor: 'blackAlpha.300',
  mx: '2',
};

export const toteMultiGrid: CSSObject = {
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '6',
  display: 'grid',
};

export const toteMultiGridText: CSSObject = {
  fontSize: 'xs',
  w: 'full',
  color: 'white',
  mb: '2',
  '&.raceNumber': {
    borderBottom: '1px dashed',
    borderColor: '#00000040',
    boxShadow: '0px 1px 0px 0px #FFFFFF1A',
  },
};